<template>
  <div>
    DEVELOPMENT <br />
    <br />
    TextFormattingButtons
    <br /><br />
    <TextFormattingButtons :options="optionsTextFormattingButtons" />
    Clicked button: <b>{{ clickedButtonFromTextFormattingButtons }}</b>
  </div>
</template>

<script>
import TextFormattingButtons from 'components/buttons/TextFormattingButtons.vue';

export default {
  components: {
    TextFormattingButtons
  },
  data() {
    return {
      clickedButtonFromTextFormattingButtons: 'none',
      optionsTextFormattingButtons: {
        boldCallback: () => {
          this.clickedButtonFromTextFormattingButtons = 'bold';
        },
        italicCallback: () => {
          this.clickedButtonFromTextFormattingButtons = 'italic';
        },
        underlineCallback: () => {
          this.clickedButtonFromTextFormattingButtons = 'underline';
        }
      }
    };
  },

  computed: {},

  methods: {}
};
</script>

<style lang="scss" scoped></style>
